import {AbstractControl, ValidationErrors} from '@angular/forms';

export function telefonoValidator(control:AbstractControl) : ValidationErrors | null {

    const value = control.value;
    if (!value) {
        return null;
    }

    const regexp = /^\+{0,1}[0-9]+$/;
    const test = regexp.test(value);

    return !test ? {numeroInvalido:true}: null;
}